import { render, staticRenderFns } from "./orderitem.vue?vue&type=template&id=fe2b33fa&scoped=true&"
import script from "./orderitem.vue?vue&type=script&lang=js&"
export * from "./orderitem.vue?vue&type=script&lang=js&"
import style0 from "./orderitem.vue?vue&type=style&index=0&id=fe2b33fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2b33fa",
  null
  
)

export default component.exports